import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { EquipmentDetailsParams } from '../setup-equipment/setup-equipment.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '../../../app.service';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { EquipmentDetailsService } from '../equipment-details/equipment-details.service';
import { ObservationPointDetails, GenericIdName } from '../setup-implement/setup-implement.model';
import {
    ImplementForEquipmentDetails,
    SchematicAndObservationPointDetails,
    SchematicDetails,
    ComponentObservationPointDetails,
    ImplementSummaryForEquipmentDetails,
    InspectionHistoryDetails,
    InspectionDetailGroupByDate,
    ImplementHistoryVM
} from './equipment-details.model';
import { GETUpdateMeterComponent } from './components/update-meter/get-update-meter.component';
import { MatDialog } from '@angular/material/dialog';import { GETChangeJobsiteComponent } from './components/change-jobsite/change-jobsite.component';
import { GETChangeMeterUnitComponent } from './components/change-meter-unit/change-meter-unit.component';
import { ImplementActionComponent } from './components/implement-action/implement-action.component';
import { MoveToInventoryComponent } from './components/move-to-inventory/move-to-inventory.component';
import { ImplementSortComponent } from './components/implement-sort/implement-sort.component';
import { AttachImplementModalComponent } from '../attach-implement-modal/attach-implement-modal.component';
import { GETViewPhotoComponent } from '../shared/view-photo/view-photo.component';
import { PhotoModelComingFrom } from '../inspections/inspection.model';
import { GETInspectionPlannerComponent } from './components/inspection-planner/inspection-planner.component';
import { UserService } from '../../../../app/shared/services/user.service';
import { PreferencesService } from '../../preferences/preferences.service';
import { EnablePreferenceTasksVM } from '../../preferences/models/preferences.model';
@Component({
    selector: 'app-equipment-details',
    templateUrl: './equipment-details.component.html',
    styleUrls: ['./equipment-details.component.scss'],
    animations: [
        trigger(
            'enterAnimation', [
                transition(':enter', [
                    style({ transform: 'translateY(25%)', opacity: 0 }),
                    animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ transform: 'translateY(0)', opacity: 1 }),
                    animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
                ])
            ]
        )]
})
export class EquipmentDetailsComponent implements OnInit {

    private equipmentId: number = 0;
    selectedImplement: number = 196 // for testing purpose
    observationListFiltered: ObservationPointDetails[] = []
    equipmentDetails: EquipmentDetailsParams;
    inspectionsLoaded: boolean = false
    //appUris: AppUris;
    makeList: GenericIdName[] = [];
    inspectionDetails: InspectionDetailGroupByDate[];
    wearStyleId:number;

    ImplementForEquipmentDetails: ImplementForEquipmentDetails[] = [];
    ImplementSummary: ImplementSummaryForEquipmentDetails[];
    SchematicAndObservationPointDetails: SchematicAndObservationPointDetails[] = []
    SchematicDetails: SchematicDetails[] = [];
    ObservationPointDetails: ComponentObservationPointDetails[];
    loading:boolean=false
    loading_imp:boolean=false
    CustomerId: number;
    historyDetails_ :ImplementHistoryVM[]=[];

    isJobRoleDefault:boolean=true;
    constructor(private _sanitizer: DomSanitizer,
        private _route: ActivatedRoute, private _router: Router,
        private _equipmentDetailsService: EquipmentDetailsService,
        private _appService: AppService, private _implementService: SetupImplementService,private _user:UserService,
        private _dialog: MatDialog, private _ref: ChangeDetectorRef,
        private readonly _pref: PreferencesService, ) { }


    ngOnInit() {
        this._route.params.subscribe(params => {
            this.equipmentId = +params['equipmentId'];

            if (this.equipmentId) {
                this.initialise();
            }
        });

        this._appService.setPageTitle('Equipment Details');
        //this._appService.setPageSubTitle('');
        //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
        this.GetPreferenceTaskList();
    }

    initialise() {
        this.LoadJobRoles();
        this.getGETWearSurfaceReportSyle();
        this.loadEquipmentDetails();
        this.loadMakes();

        this.loadImplementDetails1();
        this.loadEquipmentInspectionDetails();
      
    }
    LoadJobRoles(){
        this._user.getUserJobRoles().subscribe(roles=>{
            roles.forEach(r => {
                switch (r.Name) {
                    case 'Inspectors':
                        this.isJobRoleDefault = false;
                        break;
                    case 'Interpreters':
                        this.isJobRoleDefault = false;
                        break;
                    case 'Super User':  
                        this.isJobRoleDefault = false;
                        break;
                    case 'Administrator':
                        this.isJobRoleDefault = false;
                        break;
                        case 'Customer Admin':
                            this.isJobRoleDefault = false;
                            break;
                }
            });
          
        })
    }

    
    getGETWearSurfaceReportSyle(){
        this._equipmentDetailsService.GetGETWearSurfaceReportStyle(this.equipmentId).subscribe(res=>{
            if(res!= null){
                this.wearStyleId = res;
            }
        })

        //console.log(" this.wearStyleId",  this.wearStyleId)
    }
    loadImplementDetails1() {

        this.loading_imp = true;
        this._equipmentDetailsService.GetImplementsAndSchematics(this.equipmentId).subscribe(details => {
            this.ImplementForEquipmentDetails = details;
            //console.log("details",details)
            this.loading_imp=false
        });
        this.loadImplementHistoryByEquipment();
    }

    loadImplementHistoryByEquipment()
    {
        this._equipmentDetailsService.GetImplementsHistoryByEquipment(this.equipmentId).subscribe(res =>{
            this.historyDetails_ = res;
            this.totalsmu = Math.max.apply(Math, this.historyDetails_.map(function(o) { return o.HoursDiff; }))
            this.totalbcm = Math.max.apply(Math, this.historyDetails_.map(function(o) { return o.BCM; }))

            //console.log("result," ,this.historyDetails_ )
            this.GetTotalsDetails();
        })
    }

    totalcost:number=0;
    totalsmu:number=0;
    totalbcm:number=0;
    totaltons:number=0;
    totalcycle:number;
    GetTotalsDetails(){
        let cost=0;
        let smu=0;
        let bcm=0;
        let ton=0;
        this.historyDetails_.map(x=>{
            cost = cost+ x.Cost;
            bcm = bcm+x.BCM
            ton = ton+x.Tons
           })
           this.totalcost=cost;
           this.totalsmu=this.totalsmu
           this.totalbcm=this.totalbcm//bcm //tt-3975
           this.totaltons=ton; 

           
       if( this.totalcost == -Infinity)
       this.totalcost=0
       if(this.totalsmu == -Infinity)
       this.totalsmu=0
       if(this.totalbcm == -Infinity)
       this.totalbcm=0
       if(this.totaltons == -Infinity)
       this.totaltons=0
          /// console.log("cost," ,this.totalcost )
        //    console.log("totalsmu," ,this.totalsmu )
        //    console.log("totalbcm," ,this.totalbcm )
        //    console.log("totaltons," ,this.totaltons )
          

    }

    ToDecimalPoints(val1,val2){
        let costper= val1/val2;
        if(costper == Infinity)
        costper=0;
        //console.log("costper," ,costper.toFixed(2) )
        return costper.toFixed(2);
    }

    loadEquipmentDetails() {
        this._equipmentDetailsService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
            this.equipmentDetails = equipment;
            this.loadObservationPointsForImplement();
            this.CustomerId = this.equipmentDetails.CustomerId;
        });
    }

    loadEquipmentInspectionDetails() {
        this._equipmentDetailsService.GetEquipmentInspectionHistory(this.equipmentId).subscribe(inspections => {
            this.inspectionDetails = inspections;
        })
    }

    getImage(image: string) {
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }

    //open Inspection Planner
    openInspectionPlannerDialog() {
        const inspectionPlannerDialog = this._dialog.open(GETInspectionPlannerComponent, {
            panelClass: 'removeModalOverflow',
            data: {
                equipmentId: this.equipmentId,
            },
            minWidth: 300
        });

        inspectionPlannerDialog.afterClosed().subscribe(result => {

            if (result) {
                this.loadEquipmentDetails();
            }
        });
    }

    //preview equipment image
    viewObservationImages(equipmentDetails) {
        //console.log("equipmentDetails",equipmentDetails)
        const passingData = {
            comingFrom: PhotoModelComingFrom.EquipmentDetails,
              equipmentId: equipmentDetails.equipmentId,
              //image: 'data:image/png;base64,' +equipmentDetails.EquipmentPhoto,
              image: equipmentDetails.EquipmentPhoto,
        };
        //console.log('passingData',passingData)
    
        const viewCommentModalRef = this._dialog.open(GETViewPhotoComponent, {
          width: '1032px',
          data: passingData,
    
        });
        viewCommentModalRef.afterClosed().subscribe(changes => {
          if (changes) {
            this.loadEquipmentDetails()
          }
        });
      }

    loadObservationPointsForImplement() {
        this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
            this.observationListFiltered = r;
        });
    }

    getMakeById(id) {
        if (this.makeList != null && this.makeList.length > 0) {
            var makeDesc = this.makeList.find(w => w.Id == id);
            if (makeDesc != null) {
                return makeDesc.Name;
            }
            return "";
        }
        return "";
    }

    // Implement Makes
    loadMakes() {
        this._implementService.GetImplementMakes().subscribe(r => {
            this.makeList = r;
        });
    }



    //open update meter unit dialog

    openUpdateMeter() {
        const updateMeterDialog = this._dialog.open(GETUpdateMeterComponent, {
            panelClass: 'removeModalOverflow',
            data: {
                equipmentId: this.equipmentId,
                customerId: this.equipmentDetails.CustomerId,
                smuPrechange: this.equipmentDetails.Smu,
                lastUpdateTime: this.equipmentDetails.LastInspectionDate,
                bcmPrechange: this.equipmentDetails.Bcm,
                tonPrechange: this.equipmentDetails.Ton,

            }
        });

        const instance = updateMeterDialog.componentInstance;
        instance.changeLateUpdateTime(this.equipmentDetails.LastInspectionDate);

        updateMeterDialog.afterClosed().subscribe(newMeterReading => {
            if (newMeterReading === undefined)
                return;

            if (newMeterReading) {
                this.loadEquipmentDetails();
                // this.loadEquipmentSystems();
            }
        });
    }

    //open change jobsite

    openChangeJobsite() {
        const dialogRef = this._dialog.open(GETChangeJobsiteComponent, {
            panelClass: 'removeModalOverflow',
            data: {
                equipmentId: this.equipmentId,
                customerId: this.equipmentDetails.CustomerId
            }
        });

        dialogRef.afterClosed().subscribe(newJobsiteName => {
            if (newJobsiteName == null || newJobsiteName === undefined)
                return;
            if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
                // this.equipmentDetails.JobsiteName = newJobsiteName;
                this.loadEquipmentDetails();
            }
        });
    }


    openImplementAction() {
        const dialogRef = this._dialog.open(ImplementActionComponent, {
            panelClass: 'removeModalOverflow',
            disableClose:true,
            data: {
                equipmentId: this.equipmentId,
                customerId: this.equipmentDetails.CustomerId,
                currentSmu:this.equipmentDetails.Smu,
            }
        });

        dialogRef.afterClosed().subscribe(r => {

        });
    }

    //open change meter unit
    openChangeMeterUnit() {
        const changeMeterUnitDialog = this._dialog.open(GETChangeMeterUnitComponent, {
            data: {
                equipmentId: this.equipmentId,
                customerId: this.equipmentDetails.CustomerId,
                smuPrechange: this.equipmentDetails.Smu,
                Ltd:this.equipmentDetails.Ltd
            }
        });

        changeMeterUnitDialog.afterClosed().subscribe(changeReadingUnit => {
            if (changeReadingUnit === undefined)
                return;

            if (changeReadingUnit) {
                this.loadEquipmentDetails();
            }
        });

    }

    //open move to invetory
    OpenMovetoInventory() {
        const movetoInventoryDialog = this._dialog.open(MoveToInventoryComponent, {
            data: {
                jobsiteId: this.equipmentDetails.JobsiteId,
                jobsiteName:this.equipmentDetails.JobsiteName,
                equipmentId: this.equipmentId,
                equipmentSMU: this.equipmentDetails.Smu,
            }
        });

        movetoInventoryDialog.afterClosed().subscribe(MoveToInventory => {
            if (MoveToInventory === undefined)
                return;

            if (MoveToInventory) {
                this.loadEquipmentDetails();
            }
        });

    }


    //open Implement sort order
    openImplementSortOrder() {
        const dialogRef = this._dialog.open(ImplementSortComponent, {
            data: {
                equipmentId: this.equipmentId,
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.loadImplementDetails1();
        });
    }

    //open Move from inventory
openAttachImplementModal() {
    let openAttachImplementModalRef = this._dialog.open(AttachImplementModalComponent, {
        width: '550px',
        data: {
            jobsiteId:  this.equipmentDetails.JobsiteId,
            jobsiteName:this.equipmentDetails.JobsiteName,
            equipmentId :this.equipmentDetails.equipmentId,
            modelName : this.equipmentDetails.Model,
            equipmentName : this.equipmentDetails.SerialNumber ,
            smu:this.equipmentDetails.Smu,
        }
    });
    openAttachImplementModalRef.afterClosed().subscribe(() => {
       this.initialise();
    });
}

    getEvalClass(wornPct: number) {
        if (wornPct <= 30) {
            return " WornPctCell evalColorA";
        }
        else if ((wornPct > 30) && (wornPct <= 60)) {
            return " WornPctCell evalColorB";
        }
        else if ((wornPct > 60) && (wornPct <= 80)) {
            return " WornPctCell evalColorC";
        }
        else if (wornPct > 80) {
            return "WornPctCell evalColorX";
        }
        return " WornPctCell noEval";
    }

    getEvalCode(evalcode: string) {
        if (evalcode == 'A') {
           // return "evalColorACode";
           return " WornPctCell evalColorA";
        }
        else if (evalcode == 'B') {
            //return "evalColorBCode";
            return " WornPctCell evalColorB";
        }
        else if (evalcode == 'C') {
            //return "evalColorCCode";
            return " WornPctCell evalColorC";
        }
        else if (evalcode == 'X') {
            //return "evalColorXCode";
            return "WornPctCell evalColorX";
        }
        return " noEvalCode";
      }


      openInspection() {

      }

    openLink(target: string, date: string, selectedInspection: InspectionHistoryDetails) {

      const dateTime = new Date(selectedInspection.ActualDate);
      const gotday = dateTime.getDate();
      const gotmonth = dateTime.getMonth() + 1;
      const gotyear = dateTime.getFullYear();

      if (target === 'inspection') {
       // this._router.navigate(['/get-interpretation', this.equipmentId, gotyear, gotmonth, gotday ]);
        
     //   window.open('/get-interpretation/'+ this.equipmentId+'/'+ gotyear+'/'+ gotmonth+'/'+ gotday , '_blank')

     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
        if(res=="True"){
            this._router.navigate(['/get-interpretation', this.equipmentId, gotyear, gotmonth, gotday ]);
        }else{             
            window.open('/get-interpretation/'+ this.equipmentId+'/'+ gotyear+'/'+ gotmonth+'/'+ gotday , '_blank')
         
        }
    });


      } else if (target === 'pdf') {


        try {
          var dateParts = date.split('/');
          var months = [
              { id: "01", name: "Jan" },
              { id: "02", name: "Feb" },
              { id: "03", name: "Mar" },
              { id: "04", name: "Apr" },
              { id: "05", name: "May" },
              { id: "06", name: "Jun" },
              { id: "07", name: "Jul" },
              { id: "08", name: "Aug" },
              { id: "09", name: "Sep" },
              { id: "10", name: "Oct" },
              { id: "11", name: "Nov" },
              { id: "12", name: "Dec" }
          ];

          var day = dateParts[0];
          var month = months.find(f => f.name == dateParts[1]).id;
          var year = dateParts[2];

          var dateParsed = year + month + day;

          switch (target) {
              // case 'inspection':
              //     //window.open(this.appUris.GETUri + 'inspection/' + dateParsed, '_blank');
              //     break;
              case 'pdf':
                  //window.open(this.appUris.UCUri + 'api/GETinspection/GetPdf?id=' + this.equipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
                  window.open(this._appService.getBaseURL() + 'api/GETinspection/GetPdf?id=' + this.equipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
                  break;
          }
      } catch(e) {
          //console.log(e);
      }
      }



    }

    EnablePreference:EnablePreferenceTasksVM
    GetPreferenceTaskList(){
        this._pref.getPreferenceTaskListForLoggedUser().subscribe(res=>{
        this.EnablePreference=res
        })
    }
}
